<mat-sidenav-container newRouteToTop class="sidenav-container" (backdropClick)="closeSidenav()">
  <mat-sidenav-content>
    <div *ngIf="!isFullscreenPage; then regularPage; else fullscreenPage" class="layout-component"></div>
  </mat-sidenav-content>
  <mat-sidenav #sidenav mode="over" position="end" opened="false" class="sidenav" [fixedInViewport]="true" [autoFocus]="false" [disableClose]="true">
    <app-flyout></app-flyout>
  </mat-sidenav>
</mat-sidenav-container>

<app-explainer-dialog *ngIf="isExplain"></app-explainer-dialog>

<ng-template #regularPage>
  <div id="layout-container" [class.layout--expanded-toplevel]="isTopLevelMenuExpanded()">
    <div class="header-section">
      <top-menu [color]="this.layoutColor" [currentTitle]="currentTitle" [isBetaItem]="isBetaItem" (closeSideMenu)="sideMenu.closeMenu()"></top-menu>
      <button class="side-menu-button" type="button" [disabled]="disableMenu" mat-icon-button (click)="sideMenu.openCloseMenu()">
        <span class="btn-label"><mat-icon class="side-menu-button__icon">menu</mat-icon></span>
      </button>
    </div>

    <app-bar-loader></app-bar-loader>

    <app-top-level-side-menu></app-top-level-side-menu>
    <app-mobile-nav></app-mobile-nav>
    <side-menu #sideMenu (onCurrentColorChanged)="setLayoutColor($event)"></side-menu>

    <div
      [ngClass]="
        'main-content' +
        (' main-content--' + this.layoutColor) +
        (' main-content--' + (sideMenu && sideMenu.isOpen ? 'compact' : 'full')) +
        (' main-content--' + (sideMenu && sideMenu.isOpenInMobile ? 'mobile-compact' : 'mobile-full'))
      ">
      @if (inactiveAccountView(); as inactiveAccount) {
        <app-inactive-account-banner [accountName]="inactiveAccount.name" [siteId]="inactiveAccount.siteId"></app-inactive-account-banner>
      }
      <div *ngIf="true; then templateWithNgContent"></div>
    </div>
    <app-verify-user-message [sideMenuIsOpen]="sideMenu?.isOpen"></app-verify-user-message>
  </div>
</ng-template>

<ng-template #fullscreenPage>
  <app-bar-loader [hidden]="false"></app-bar-loader>
  <div *ngIf="true; then templateWithNgContent"></div>
</ng-template>

<ng-template #templateWithNgContent>
  <ng-content></ng-content>
</ng-template>
